import React from 'react';

import {complete} from 'account-portal-library/lib/appleSignIn';
import {parseCookies, validateSessionToken, isValidGoToURL} from 'account-portal-library/lib/helperFunctions'

import Loader from '../Loader';
import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';
import { getGotoUrlFromCookies } from '../../gotoUrl';


let appVars = AppVars.getInstance();
let logger = Logger.getInstance();

const VALID_FAILURE_URL = ["/noemail"]

class ContinueApple extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            complete: false,
            payload: null,
        }
    }

    //Finishes Google sign in flow
    async continueApple(){
        logger.log("stage", "Continuing Apple Sign In");
        let response = await complete(appVars.getBaseUrl(), appVars.getRealm(), appVars.getAppleSignInTree(), appVars.getDomain(), appVars.getName());
        logger.log("test", "Continue Apple Response");
        logger.log("test", response);
        if (response.status > 299){
            this.handleFailure(response);
        } else {
            this.handleSuccess(response);
        }
        
    }

    async checkToken(loginResponse){
        try {
            var tokenId = loginResponse.response.tokenId
            if (tokenId != null){
                logger.log("test", tokenId)
                var validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                logger.log("test", validateResponse)
                return validateResponse.response.valid;
            } else{
                return false
            }
        }
        catch{
            return false
        }
        
    }

    async handleSuccess(loginResponse){
        if (loginResponse.response.tokenId != null && loginResponse.response.tokenId != undefined){
            var tokenValid = await this.checkToken(loginResponse)
            if (tokenValid){
                const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
                window.location.replace(gotoUrl);
            } else {
                window.location.replace(appVars.getUnknownErrorURL(this.props.style));
            }
        } else{
            this.props.savePayload(loginResponse)
        }
        
    }

    handleFailure(loginResponse){
    var failureUrl = loginResponse.failureUrl
    if (VALID_FAILURE_URL.includes(failureUrl)){
        window.location.replace(failureUrl);
    }else {
        //this.setState({loading: false})
        window.location.replace(appVars.getUnknownErrorURL(this.props.style));
        }
    }


    render(){
        this.continueApple();
        return(
            <Loader />
        )
    }
}
    


export default ContinueApple;